import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-[60vh] items-center justify-center px-4">
      <div className="text-center">
        <XCircle size={56} className="mx-auto text-amber-500" />
        <h1 className="mt-4 font-heading text-xl font-bold text-navy">Payment cancelled</h1>
        <p className="mt-2 text-slate-600">Your booking is saved as pending. You can complete payment anytime from your dashboard.</p>
        <div className="mt-6 flex justify-center gap-2">
          <Button variant="outline" onClick={() => navigate("/")}>Back Home</Button>
          <Button className="bg-brand hover:bg-brand/90" onClick={() => navigate("/dashboard")} data-testid="cancel-dashboard">Go to Dashboard</Button>
        </div>
      </div>
    </div>
  );
}
